import { LandingApp } from "@site/LandingApp";
import { LocaleProvider } from "@site/LocaleContext";
import { createRoot } from "react-dom/client";

export function mountLandingPage(): void {
  const root = document.getElementById("site-root");
  const canvas = document.getElementById("renderCanvas") as HTMLCanvasElement | null;
  const hudRoot = document.getElementById("hud-root") as HTMLElement | null;

  if (!root || !canvas || !hudRoot) {
    throw new Error("Landing page elements not found.");
  }

  createRoot(root).render(
    <LocaleProvider>
      <LandingApp canvas={canvas} hudRoot={hudRoot} />
    </LocaleProvider>,
  );
}
